import { GUIDES } from './registry';

// Which guides an account's onboarding list shows.
//
// Placeholder until the chatbot's answers and BE's storage exist: it returns
// every registered guide, in registry order. Once BE decides how the chosen
// guides are stored, this is the one function that changes (it will also
// apply eligibility: feature flags, plan, module).
/**
 * @param {number|string} accountId
 * @returns {string[]} guide ids
 */
// eslint-disable-next-line no-unused-vars
export const getSelectedGuideIds = accountId => Object.keys(GUIDES);
